import { StateParams, StateService } from "@uirouter/angularjs";
import { IOnInit, IPromise } from "angular";
import {
  IFieldArray,
  IFieldRuntimeObject,
  ITemplateScope,
} from "AngularFormly";
import { FormViewController } from "../../../../../../app/records/forms/formView/controller";
import { set } from "lodash";
import {
  vsName as serverUtilityName,
  ServerUtility,
} from "../../../../../../app/records/server/serverUtility";

import {
  FormViewService,
  vsName as FormViewServiceName,
} from "../../../../../../app/records/forms/formView/service";
import fieldHelpers from "../../../../../../app/ui-formly/fieldHelpers";

import {
  FieldConfigurationHelperService,
  vsName as FieldConfigurationHelperServiceName,
} from "../../../../../../app/records/forms/formly/fieldConfigurationHelpers";
import { vsObjectName as typeOfAgreementName } from "../../../../configs/typeOfAgreement";
import {
  vsServiceName as LookupModalServiceName,
  LookupModalService,
} from "../../../../../records/lookup/lookupModal";
import { LookupManagementService } from "../../../../../records/lookup/lookupManagement";
import { vsLookupManagementServiceName as LookupManagementServiceName } from "../../../../configs/lookupManagement";
import { vsObjectName as performanceGuaranteeName } from "../../../../configs/performanceGuaranteeType";
import { vsObjectName as feeStructureName } from "../../../../configs/feeStructureType";
import { vsObjectName as costTypeName } from "../../../../configs/costType";
import { vsObjectName as contractMachineManufacturerName } from "../../../../configs/contractMachineManufacturer";
import { Contract } from "../../../../shared/models/contract";
import { ContractConfiguration } from "../../../../shared/models/contractConfiguration";
import { ensureEnabledQueryBuilder } from "../../../../../records/forms/formly/types/recordSelectAsync/utils";
import { ContractTypeService } from "../../../../shared/ContractService";
import { Record } from "../../../../../records/server/crud";

export class GamingContractEditController implements IOnInit {
  static $inject = [
    FormViewServiceName,
    "$state",
    FieldConfigurationHelperServiceName,
    "$stateParams",
    "slotTrakMachinesServer",
    serverUtilityName,
    LookupModalServiceName,
    LookupManagementServiceName,
  ];
  formFields!: IFieldArray;
  contract!: any;
  contractType!: ContractTypeService;

  constructor(
    private readonly formViewService: FormViewService,
    private readonly $state: StateService,
    private readonly fieldConfigurationHelperService: FieldConfigurationHelperService,
    public readonly $stateParams: StateParams,
    public readonly slotTrakMachinesServer: any,
    public readonly serverUtility: ServerUtility,
    private readonly lookupModalService: LookupModalService,
    private readonly lookupManagementService: LookupManagementService
  ) {}

  private nullWhenNotValue(watch: string, value: string) {
    return {
      expression: watch,
      listener: (
        field: IFieldRuntimeObject,
        newValue: any,
        _: any,
        scope: ITemplateScope
      ) => {
        if (newValue !== value) {
          const path = field.key ?? "";
          set(scope.model ?? {}, path, undefined);
        }
      },
    };
  }

  private initializeFormFields() {
    const that = this;
    const detailsField = fieldHelpers.simpleStringField({
      key: "Details",
      name: "Details",
      label: "Details ",
      hideExpression: "model.OwnedLeased !== 'Owned'",
      expressionProperties: {
        "templateOptions.required": "model.OwnedLeased === 'Owned'",
      },
      className: "col-xs-6",
      watcher: [that.nullWhenNotValue("model.OwnedLeased", "Owned")],
    });

    this.formFields = [
      ...fieldHelpers.columnLayout(
        [
          that.fieldConfigurationHelperService.selectAsyncField({
            key: "PropertyId",
            name: "PropertyId",
            label: "Property",
            required: true,
            queryUrl: "/api/properties",
            getDefaultItem: function (model) {
              return { Id: model.Property?.Id, Name: model.Property?.Name };
            },
          }),
          that.fieldConfigurationHelperService.selectAsyncField({
            key: "ContractMachineManufacturerId",
            name: "ContractMachineManufacturerId",
            label: "Manufacturer",
            required: true,
            queryUrl: "/api/machines/manufacturers",
            queryBuilder: ensureEnabledQueryBuilder(),
            getDefaultItem: function (model: any) {
              return {
                Id: model.ContractMachineManufacturer?.Id,
                Name: model.ContractMachineManufacturer?.Name,
              };
            },
            addonRight: this.lookupModalService.getDropdownAddAddon(
              this.lookupManagementService,
              contractMachineManufacturerName,
              (manufacturer: any) => {
                that.contract.ContractMachineManufacturerId = manufacturer.Id;
              },
              "machineEdit",
              undefined,
              (manufacturer) => manufacturer
            ),
          }),

          that.fieldConfigurationHelperService.selectAsyncField({
            key: "TypeOfAgreementId",
            name: "TypeOfAgreementId",
            label: "Type Of Agreement",
            required: true,
            queryUrl: "/api/contract/typesOfAgreement",
            queryBuilder: ensureEnabledQueryBuilder(),
            getDefaultItem: function (model: any) {
              return {
                Id: model.TypeOfAgreement?.Id,
                Name: model.TypeOfAgreement?.Name,
              };
            },
            addonRight: this.lookupModalService.getDropdownAddAddon(
              this.lookupManagementService,
              typeOfAgreementName,
              (typeOfAgreement: any) =>
                (that.contract.TypeOfAgreementId = typeOfAgreement.Id),
              "contractLookupModify"
            ),
          }),
          fieldHelpers.simpleStringField({
            key: "ContractNumber",
            name: "ContractNumber",
            label: "Contract Number",
          }),
          fieldHelpers.simpleDateField({
            key: "ContractStartDate",
            name: "ContractStartDate",
            label: "Contract Start ",
            required: true,
          }),
          fieldHelpers.simpleDateField({
            key: "ContractEndDate",
            name: "ContractEndDate",
            label: "Contract End ",
          }),
        ],
        4
      ),
      ...fieldHelpers.columnLayout(
        [
          fieldHelpers.simpleStringField({
            key: "Cbr",
            name: "Cbr",
            label: "Cbr#",
          }),
          fieldHelpers.simpleStringField({
            key: "Requisition",
            name: "Requisition",
            label: "Requisition#",
          }),
          fieldHelpers.simpleStringField({
            key: "PO",
            name: "PO",
            label: "PO#",
          }),
          fieldHelpers.simpleCurrencyField({
            key: "ContractValue",
            name: "ContractValue",
            label: "Contract Value",
          }),
        ],
        4
      ),
      ...fieldHelpers.columnLayout(
        [
          {
            key: "OwnedLeased",
            name: "OwnedLeased",
            type: "select",
            templateOptions: {
              label: "Owned/Leased",
              options: [
                {
                  label: "Leased",
                  value: "Leased",
                },
                {
                  label: "Owned",
                  value: "Owned",
                },
              ],
              required: true,
              labelProp: "label",
              valueProp: "value",
            },
          },
        ],
        4
      ),
      ...fieldHelpers.columnLayout(
        [
          that.fieldConfigurationHelperService.selectAsyncField({
            key: "PerformanceGuaranteeTypeId",
            name: "PerformanceGuaranteeTypeId",
            label: "Performance Guarantee",
            queryUrl: "/api/contract/performanceGuaranteeType",
            hideExpression: "model.OwnedLeased !== 'Owned'",
            expressionProperties: {
              "templateOptions.required": "model.OwnedLeased === 'Owned'",
            },
            queryBuilder: ensureEnabledQueryBuilder(),
            getDefaultItem: function (model: any) {
              return {
                Id: model.PerformanceGuaranteeType?.Id,
                Name: model.PerformanceGuaranteeType?.Name,
              };
            },
            addonRight: this.lookupModalService.getDropdownAddAddon(
              this.lookupManagementService,
              performanceGuaranteeName,
              (value) => (that.contract.PerformanceGuaranteeTypeId = value.Id),
              "contractLookupModify"
            ),
            watcher: [that.nullWhenNotValue("model.OwnedLeased", "Owned")],
          }),
          detailsField,
          that.fieldConfigurationHelperService.selectAsyncField({
            key: "FeeStructureTypeId",
            name: "FeeStructureTypeId",
            label: "Fee Structure",
            queryUrl: "/api/contract/feeStructureType",
            hideExpression: "model.OwnedLeased !== 'Leased'",
            expressionProperties: {
              "templateOptions.required": "model.OwnedLeased === 'Leased'",
            },
            queryBuilder: ensureEnabledQueryBuilder(),
            getDefaultItem: function (model: any) {
              return {
                Id: model.FeeStructureType?.Id,
                Name: model.FeeStructureType?.Name,
              };
            },
            addonRight: this.lookupModalService.getDropdownAddAddon(
              this.lookupManagementService,
              feeStructureName,
              (value) => (that.contract.FeeStructureTypeId = value.Id),
              "contractLookupModify"
            ),
            watcher: [that.nullWhenNotValue("model.OwnedLeased", "Leased")],
          }),
        ],
        4
      ),

      fieldHelpers.headerField({
        headerText: "Costs",
        key: "CostsHeader",
      }),

      that.fieldConfigurationHelperService.repeaterField({
        key: "Costs",
        name: "Costs",
        label: "Costs",
        allowAdd: true,
        allowAddBottom: true,
        displayNameSingular: "Row",
        displayNamePlural: "Rows",
        repeaterFields: [
          {
            className: "row",
            fieldGroup: [
              ...fieldHelpers.columnLayout(
                [
                  that.fieldConfigurationHelperService.selectAsyncField({
                    key: "CostTypeId",
                    name: "CostTypeId",
                    label: "Cost Type",
                    queryUrl: "/api/contract/costType",
                    queryBuilder: ensureEnabledQueryBuilder(),
                    getDefaultItem: function (model: any) {
                      return {
                        Id: model.CostType?.Id,
                        Name: model.CostType?.Name,
                      };
                    },
                    onSelect(selectedItem: any, model: any) {
                      model.CostType = selectedItem;
                    },
                    addonRight: this.lookupModalService.getDropdownAddAddon(
                      this.lookupManagementService,
                      costTypeName,
                      (value, scope) =>
                        ((<any>scope).model.CostTypeId = value.Id),
                      "contractLookupModify"
                    ),
                  }),
                  fieldHelpers.simpleCurrencyField({
                    key: "Cost",
                    name: "Cost",
                    label: "Cost",
                  }),
                  {
                    key: "copyDelete",
                    type: "recordRepeaterCopyDelete",
                    templateOptions: {
                      label: " ",
                    },
                  },
                ],
                4
              ),
            ],
          },
        ],
        showHeader: false,
      }),

      fieldHelpers.headerField({
        headerText: "Notes",
        key: "NotesHeader",
      }),
      fieldHelpers.textAreaField({
        key: "Notes",
        name: "Notes",
        label: " ",
        rows: 5,
      }),
      {
        key: "Files",
        name: "Files",
        type: "recordFileUpload",
        templateOptions: {
          label: "Source Documents",
          allowMultiple: true,
        },
      },
      fieldHelpers.headerField({
        headerText: "Executed Contract",
        key: "ExecutedContractHeader",
      }),
      ...fieldHelpers.columnLayout(
        [
          {
            key: "ExecutedContract",
            name: "ExecutedContract",
            type: "fileUploadSingle",
            templateOptions: {
              label: "",
            },
          },
        ],
        1
      ),
    ];

    detailsField.className = "col-xs-6";
  }

  $onInit(): void {
    this.initializeFormFields();    
    this.contract.Id = this.contract?.ContractInstanceId;
  }

  submit(formViewController: FormViewController): IPromise<void> {
    return this.contractType
      .submitContract(this.contract, formViewController)
      .then((result) => {
        this.contractType.infoNavigate(result.ContractInstanceId);
      });
  }

  cancel(): IPromise<void> {
    return this.$state.go("^.redirect").then();
  }
}
